//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { getData, getAllKeys, getAllNodes, filterTree, statisticsAsync } from './data';
import diff from '@/components/diff/show.vue';
import CodeDiff from '@/components/codeDiff';
import config from '@/config';
const modelTypes = [
  { value: 'diff_menu', label: '菜单' },
  { value: 'diff_api', label: '接口' },
  { value: 'diff_element', label: '元素' },
  { value: 'diff_object', label: '对象' },
  { value: 'diff_role', label: '角色' },
];
const operateTypes = [
  { value: 'CREATE', label: '新增' },
  { value: 'MODIFY', label: '修改' },
  { value: 'DELETE', label: '删除' },
];
const diffTypes = [
  'diff_menu',
  'diff_api',
  'diff_element',
  'diff_object',
  'diff_object_field',
  'diff_role',
];
export default {
  components: { diff, CodeDiff },
  data() {
    return {
      modelTypes,
      operateTypes,
      sync_id: '',
      loading: false,
      diffData: {}, // 全部数据
      filterDiffData: {}, // 过滤后的数据
      defaultProps: {},
      fails: [],
      checkList: {
        config: [],
        perm: [],
      },
      asyncForm: {
        model: modelTypes.map((item) => {
          return item.value;
        }),
        operator: operateTypes.map((item) => {
          return item.value;
        }),
      },
      config,
      tipDaig: {
        visible: false,
        asyncData: {
          config: [],
          perm: [],
        },
      },
      difDialog: {
        visible: false,
        oldStr: '',
        newStr: '',
        title: '',
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        asyncIam: this.getElementList.includes('async-iam'),
      };
    },
    allKey() {
      return {
        config: getAllKeys(this.filterDiffData.config),
        perm: getAllKeys(this.filterDiffData.permission),
      };
    },
    allNode() {
      return {
        config: getAllNodes(this.filterDiffData.config),
        perm: getAllNodes(this.filterDiffData.permission),
      };
    },
    modelInfo() {
      const obj = {
        diff_object_field: '字段',
      };
      modelTypes.forEach((item) => {
        obj[item.value] = item.label;
      });
      return obj;
    },
  },
  created() {
    this.init();
  },
  methods: {
    showDiff({ oldStr, newStr, title }) {
      this.difDialog = {
        visible: true,
        oldStr,
        newStr,
        title,
      };
    },
    init() {
      const { env, tag, appid } = this.$route.query;
      if ([env, tag, appid].includes(undefined)) {
        this.$router.replace({
          name: 'version-manage',
        });
      }
      this.sync_id = '';
      this.checkList = {
        config: [],
        perm: [],
      };
      this.asyncForm = {
        model: modelTypes.map((item) => {
          return item.value;
        }),
        operator: operateTypes.map((item) => {
          return item.value;
        }),
      };
      this.fails = [];
      this.getDiff({ env, tag, appid: Number(appid) });
    },
    async getDiff(req) {
      this.loading = true;
      try {
        const { items, sync_id: syncId } = await this.$request({
          url: this.$api.diffAuth,
          data: req,
          config: {
            timeout: 1000 * 120, // 超时120s
          },
        });
        console.log('接口数据:', items);
        this.diffData = getData(items);
        console.log('diff:', this.diffData);
        this.filterDiffData = JSON.parse(JSON.stringify(this.diffData));
        this.sync_id = syncId;
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    configCheckChange(data, { checkedNodes }) {
      console.log(checkedNodes);
      this.checkList.config = checkedNodes.filter((item) => {
        return item.tier;
      });
    },
    permCheckChange(data, { checkedNodes }) {
      console.log(checkedNodes);
      this.checkList.perm = checkedNodes.filter((item) => {
        return item.tier;
      });
    },
    changeSelect() {
      this.loading = true;
      setTimeout(() => {
        const models = [...this.asyncForm.model];
        if (this.asyncForm.model.includes('diff_object')) {
          models.push('diff_object_field');
        }
        this.filterDiffData.config = filterTree(
          this.diffData.config,
          this.asyncForm.operator,
          models,
        );
        this.filterDiffData.permission = filterTree(
          this.diffData.permission,
          this.asyncForm.operator,
          models,
        );

        this.checkList = {
          config: [],
          perm: [],
        };
        this.$nextTick(() => {
          this.loading = false;
        });
      }, 300);
    },
    handleCheckAllChange(val) {
      const operator = this.asyncForm.operator.filter((item) => {
        return item !== '全选';
      });
      const model = this.asyncForm.model.filter((item) => {
        return item !== '全选';
      });

      switch (val) {
        case 'info':
          if (model.length < modelTypes.length) {
            this.asyncForm.model = modelTypes.map((item) => {
              return item.value;
            });
          } else {
            this.asyncForm.model = [];
          }
          break;
        case 'operate':
          if (operator.length < operateTypes.length) {
            this.asyncForm.operator = operateTypes.map((item) => {
              return item.value;
            });
          } else {
            this.asyncForm.operator = [];
          }
          break;
      }
    },
    selectAll() {
      // key
      const allKey = {
        config: this.allNode.config.map((item) => {
          return item.diff_code;
        }),
        perm: this.allNode.perm.map((item) => {
          return item.diff_code;
        }),
      };
      // 更新视图
      this.$refs.config.setCheckedKeys(allKey.config);
      this.$refs.perm.setCheckedKeys(allKey.perm);
      this.checkList = JSON.parse(JSON.stringify(this.allNode));
    },
    resetChecked() {
      this.$refs.config.setCheckedKeys([]);
      this.$refs.perm.setCheckedKeys([]);
      this.checkList = {
        config: [],
        perm: [],
      };
    },
    // 同步
    async operation() {
      // 同步参数
      const req = {
        sync_id: this.sync_id,
        sync_item: {
          diff_role: {},
          diff_menu: {},
          diff_element: {},
          diff_api: {},
          diff_object: {},
          diff_object_field: {},
        },
      };
      // 配置
      this.checkList.config.forEach((node) => {
        const { tier, diff_code } = node;
        if (diffTypes.includes(tier)) {
          if (!req.sync_item[tier].diff_item) {
            req.sync_item[tier].diff_item = [];
          }
          req.sync_item[tier].diff_item.push({ diff_code });
        } else {
          if (tier) {
            console.log('tier:', tier);
          }
        }
      });
      // 权限
      this.checkList.perm.forEach((node) => {
        const { tier, diff_code } = node;
        if (diffTypes.includes(tier)) {
          if (!req.sync_item[tier].diff_perm) {
            req.sync_item[tier].diff_perm = [];
          }
          req.sync_item[tier].diff_perm.push({ diff_code });
        } else {
          if (tier) {
            console.log('tier:', tier);
          }
        }
      });
      try {
        await this.$request({
          url: this.$api.syncAuth,
          data: req,
          config: {
            timeout: 1000 * 120, // 超时120s
          },
        });
        this.$message({
          message: '同步成功',
          type: 'success',
        });
        this.tipDaig.visible = false;
        this.init();
      } catch (err) {
        console.log(err);
        this.$message.error('同步失败');
      }
    },
    statisticsAsync() {
      console.log('选择节点:', this.checkList);
      if (this.checkList.config.length === 0) {
        if (this.checkList.perm.length === 0) {
          this.$message({
            type: 'warning',
            message: '请选择数据后,执行同步操作',
          });
          return;
        }
      }
      this.tipDaig.asyncData.config = [];
      this.tipDaig.asyncData.perm = [];
      const asyncData = statisticsAsync(this.checkList.config, this.checkList.perm);
      diffTypes.forEach((tier) => {
        if (asyncData.config[tier]) {
          this.tipDaig.asyncData.config.push({
            tier,
            data: asyncData.config[tier],
          });
        }
        if (asyncData.perm[tier]) {
          this.tipDaig.asyncData.perm.push({
            tier,
            data: asyncData.perm[tier],
          });
        }
      });
      this.tipDaig.visible = true;
    },
  },
};
